'use client';

import {
  DropdownItem,
  DropdownMenu,
  type DropdownProps,
  DropdownSection,
  DropdownTrigger,
  Dropdown as HeroDropdown,
  useDropdown,
} from '@heroui/dropdown';
import { cn } from '@/utils';

export function Dropdown(props: DropdownProps) {
  const { classNames, shouldBlockScroll = false, ...rest } = props;
  return (
    <HeroDropdown
      {...rest}
      shouldBlockScroll={shouldBlockScroll}
      classNames={{
        ...classNames,
        base: cn('!rounded-2xl', classNames?.base),
        content: cn('!rounded-2xl', classNames?.content),
      }}
    />
  );
}

export type {
  DropdownItemProps,
  DropdownMenuProps,
  DropdownSectionProps,
  DropdownTriggerProps,
} from '@heroui/dropdown';
export type { DropdownProps };
export { DropdownItem, DropdownMenu, DropdownSection, DropdownTrigger, useDropdown };
